import { Location } from '@angular/common';
import { AuthService } from './../../services/auth.service';
import { ExpedientesService } from './../../services/expedientes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import 'rxjs/Rx';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-provision',
  templateUrl: './provision.component.html',
  styleUrls: ['./provision.component.css']
})
export class ProvisionComponent implements OnInit {

  provision={};
  codigo;
  @ViewChild("subirArchivo") archivoSubido: ElementRef;
  @ViewChild("mensaje") mensaje:ElementRef;

  constructor(private location:Location, private auth:AuthService, private activatedRoute:ActivatedRoute,
     private expedientesService:ExpedientesService, private router:Router, private renderer:Renderer2) {
    
      if(!this.expedientesService.expedienteActivo){
        this.router.navigate(["/home"]);
      }
    
      this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
      if(this.codigo=="nuevo"){
        this.provision={};
      }else{
        this.cargarProvision();
      }
    });
   }

  ngOnInit() {
    
    
  }


  cargarProvision(){
    this.expedientesService.getProvision(this.codigo)
    .subscribe(resp=>{
      this.provision=resp["provision"];
      this.provision["EPfecha"]=this.provision["EPfecha"].substring(0,10);
    })
  }

  guardarProvision(){
    if(this.codigo=="nuevo"){
      this.insertProvision();
    }else{
      this.updateProvision();
    }
  }

  insertProvision(){
    this.expedientesService.insertProvision(this.provision, this.archivoSubido.nativeElement.files[0])
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }

  updateProvision(){
    this.expedientesService.updateProvision(this.provision,this.codigo)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 2000);
    });
  }




  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
        return myDate_string;
    } else {
        return null;
    }
  }

  volver(){
    this.location.back();
  }

  descargarAdjuntoProvision(){
    this.expedientesService.descargarAdjuntoProvision(this.provision)
    .subscribe(data=>saveAs(data, this.provision["EPficheroadjunto"])),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
  }
}



// WEBPACK FOOTER //
// ./src/app/components/provision/provision.component.ts